exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(true);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,400i,500,500i,700&display=swap);", ""]);
// Module
exports.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"font.css"}]);
